export const createPageUrl = (pageName) => {
    // If it's a relative path starting with ./ or ../ or a full URL, return as is
    if (pageName.startsWith('.') || pageName.startsWith('http')) {
        return pageName;
    }

    // Handle pages with query params (e.g. BlogArticolo?id=123)
    let path = pageName;
    let query = '';
    if (pageName.includes('?')) {
        [path, query] = pageName.split('?');
    }

    // Convert camelCase to kebab-case
    const kebabPath = path
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .toLowerCase();

    // Special cases
    if (kebabPath === 'home') return '/';

    return `/${kebabPath}${query ? '?' + query : ''}`;
};
